export default "__VITE_ASSET__BVR6PIGz__"